export function initFortunewheel() {
    //document.addEventListener('DOMContentLoaded', function () {
    try {
        const segments = window.fortunewheelSegments || [];
        const options = window.fortunewheelOptions || {};
        const modal = window.fortunewheelModal || {};

        const fortuneWheel = new FortuneWheel(segments, options, modal);
        console.log(segments);
        fortuneWheel.init();
    } catch (error) {
        console.error("Fehler bei der Initialisierung des Glücksrads:", error.message);
    }
    //});
}

class FortuneWheel {
    constructor(segments, options, modal) {

        this.segments = segments || [];

        this.options = options || {};
        this.modal = modal || {};
        this.canvas = null;
        this.spinButton = null;
        this.isSpinning = false;
        this.winningSegment = [];
        this.condition = options.condition;
        this.tau = 2 * Math.PI;
        this.arc = this.tau / segments.length
        this.tot = segments.length
        this.rad = 0;
        this.PI = Math.PI;
        this.TAU = 2 * this.PI;
        this.ang = 0;
        this.animation;
        this.angVel = 0;
        this.previousEndDegree=(this.ang - Math.PI / 2) * 180 / Math.PI;
        this.friction = 0.991;
    }

    init() {
        this.setupDOM();
        this.setupEventListeners();
        this.drawWheelDom();
        this.rotate();
        console.info("Glücksrad initialisiert");
    }

    setupDOM() {
        this.canvas = document.getElementById('fortunewheel-canvas');
        this.selection = document.getElementById('fortunewheel-selection');
        this.spinButton = document.getElementById('spin-button');
        this.fortuneWheel = document.getElementById('fortunewheel-wheel');
        this.fortuneWheelList = document.getElementById('fortunewheel-list');
        this.errorModal = $('#fortuneWheelErrorModal');
        this.errorModalMessage = $('#fortuneWheelErrorModalMessage');
    }

    setupEventListeners() {
        this.spinButton.addEventListener('click', () => {
            this.spinWheel()
        });
    }
    drawWheelDom() {
        this.fortuneWheel.style.setProperty('--items',  this.segments.length.toString());
        this.segments.forEach((segment, index) => {
            const domList = this.fortuneWheelList;
            const li = document.createElement('li');
            li.classList.add('wheel-segment');
            li.style.setProperty('--idx', (index + 1).toString());
            li.style.setProperty('--color', (segment.color).toString());
            li.dataset.index = index;
            // Wrapper span
            const wrapper = document.createElement('span');
            wrapper.classList.add('fortunewheel__segmentContainer');
            // Create description element
            const desc = document.createElement('span');
            desc.classList.add('fortunewheel__points');
            desc.innerHTML = '<span>'+segment.points + '<br/> Punkte</span>' || '';
            // Create <img>
            if (segment.image && segment.image !== "/userdata/fortunewheel/resize/") {
                const img = document.createElement('img');
                img.src = segment.image;
                img.alt = segment.description || `segment-${index}`;
                wrapper.appendChild(img);
            }else{
                wrapper.appendChild(desc);
            }



            // Append wrapper to li
            li.appendChild(wrapper);

            // Append li to domList
            domList.appendChild(li);
        });
    }
    getIndex = () => Math.floor(this.segments.length - (this.ang / this.TAU) * this.segments.length) % this.segments.length;
    spinToIndex(targetIndex, spins = 6) {
        if (this.animation) this.animation.cancel();
        // normalize index
        targetIndex = ((targetIndex % this.segments.length) + this.segments.length) % this.segments.length;

        const degreesPerSegment = 360 / this.segments.length;
        const targetAngle = targetIndex * degreesPerSegment - degreesPerSegment/2;
        const finalAngle = this.previousEndDegree + (spins * 360) + (360 - targetAngle);

        // Return a Promise that resolves when the animation finishes
        return new Promise((resolve) => {
            this.animation = this.fortuneWheelList.animate([
                { transform: `rotate(${this.previousEndDegree}deg)` },
                { transform: `rotate(${finalAngle}deg)` }
            ], {
                duration: 4000,
                easing: 'cubic-bezier(0.440, -0.205, 0.000, 1.130)',
                fill: 'forwards'
            });

            this.animation.onfinish = () => {
              //  this.previousEndDegree = finalAngle;
                resolve(); // Resolve the promise when the spin ends
            };
        });
    }
    async spinWheel() {
        if (this.isSpinning) return;

        this.isSpinning = true;
        this.spinButton.disabled = true;

        // Log loaded options
        for (const option in this.options) {
            console.log(`Geladene Option: ${option} mit Wert: ${this.options[option]}`);
        }

        const urlParts = window.location.pathname.split('/');
        const formData = new FormData();
        formData.append('siteCode', urlParts[1] || '');
        formData.append('languageCode', urlParts[2] || '');
        formData.append('function', 'checkCondition');
        formData.append('condition', this.condition);

        try {
            const response = await fetch('/module/mysydeshop/b2c/ajax.php', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error(`Fehler bei der Überprüfung der Bedingung: ${response.status}`);
            }

            const checkData = await response.json();

            console.log("Optionen: ");

            if (checkData.debugLog) {
                console.log('Debug Log:');
                checkData.debugLog.forEach(log => console.log(log));
            }

            if (checkData.success) {
                // Bedingung erfüllt → Rad drehen
                this.getRandomWin();
            } else {
                console.log("Bedingung nicht erfüllt:", checkData.message);
               this.showErrorModal(checkData.message);
               // this.getRandomWin();
            }

        } catch (error) {
            console.error("Fehler beim Überprüfen der Bedingung:", error);
        } finally {
            this.isSpinning = false;
            this.spinButton.disabled = false;
        }
    }

    rotate() {
        const sector = this.segments[this.getIndex()]
        this.selection.innerHTML = !this.angVel ? '' :  sector.text
       this.fortuneWheelList.style.transform = `rotate(${this.previousEndDegree}deg)` ;
    }

    async getRandomWin() {
        this.isSpinning = true;
        this.spinButton.disabled = true;

        // get data from url splitted by slash
        const urlParts = window.location.pathname.split('/');

        const formData = new FormData();
        formData.append('function', 'get_random_win');
        formData.append('siteCode', urlParts[1] || '');
        formData.append('languageCode', urlParts[2] || '');
        formData.append('segments', JSON.stringify(this.segments));
        formData.append('condition', this.condition);

        const extraGetPath = `?site=${urlParts[1]}&language=${urlParts[2]}`;

        try {
            const response = await fetch(`/module/mysydeshop/b2c/ajax.php` + extraGetPath, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                console.error("Fehler beim Abrufen des Gewinns:", response.status);
                this.isSpinning = false;
                this.spinButton.disabled = false;
                return;
            }

            const text = await response.text();
            console.log("Server response:", text);

            let data;
            try {
                data = JSON.parse(text);
            } catch (err) {
                console.error("Fehler beim Parsen der Serverantwort:", err);
                this.isSpinning = false;
                this.spinButton.disabled = false;
                return;
            }

            if (!data || data.status !== 'success') {
                console.error("Unerwartete Serverantwort:", data);
                this.isSpinning = false;
                this.spinButton.disabled = false;
                return;
            }

            this.winningSegment = data.winningSegment;
            console.log("Gewonnenes Segment:", this.winningSegment);

            const winningIndex = this.segments.findIndex(
                segment => parseInt(segment.id) === parseInt(this.winningSegment.id)
            );
            console.log(winningIndex);
            const winningData = this.segments.find(
                segment => parseInt(segment.id) === parseInt(this.winningSegment.id)
            );

            if (winningIndex === -1) {
                console.error("Gewinnersegment nicht in den lokalen Segmenten gefunden:", this.winningSegment);
                this.isSpinning = false;
                this.spinButton.disabled = false;
                return;
            }

            // Modal handling
            if (data.modal) {
                const parser = new DOMParser();
                const modalDoc = parser.parseFromString(data.modal, 'text/html');
                const modalContent = modalDoc.body.firstChild;

                if (modalContent) {
                    const existingModal = document.getElementById('fortunewheel-win-modal');
                    if (existingModal) existingModal.remove();

                    document.body.appendChild(modalContent);
                    console.log("Modal appended to body");
                } else {
                    console.error("No valid modal content found in the response");
                }
            } else {
                console.error("No modal content in the response");
            }
            await this.spinToIndex(winningIndex);

// Show the success modal AFTER the wheel stops
            this.showWinModal(this.winningSegment);
            this.rotate();

        } catch (error) {
            console.error("Fetch-Fehler:", error);
            this.isSpinning = false;
            this.spinButton.disabled = false;
        }
    }


    showErrorModal(message) {
        this.errorModalMessage.text(message);
        this.errorModal.modal("show");
    }

    showWinModal(segment) {
        this.modal = $("#fortunewheel-win-modal");
        console.log("Modal:" + this.modal);
        if (!this.modal) {
            console.error("Modal-Element nicht gefunden! Modal-ID:", this.modal.id);
            console.log("HTML-Inhalt des body:", document.body.innerHTML);
            return;
        }
        this.modal.modal("show");
        updatePointsInHeader();
        this.saveWinToDatabase(segment);
        //const button = this.modal.querySelector('#btnReedem');
        const button = document.getElementById('btnRedeem');
        console.log("Gefundener Button: " + button);
        if (button) {
            button.onclick = () => this.addToCart(segment);
        }
    }

    async saveWinToDatabase(segment) {
        var formData = new FormData();
        var xmlHttp = new XMLHttpRequest();
        let urlParts = window.location.pathname.split('/');

        formData.append('siteCode', urlParts[1] || '');
        formData.append('languageCode', urlParts[2] || '');
        formData.append('function', 'save_fortunewheel_history');
        formData.append('win_id', segment.id);

        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState == 4) {
                if (xmlHttp.status === 200) {
                    console.log("Server response:", xmlHttp.response);
                    let data;
                    try {
                        data = JSON.parse(xmlHttp.response);
                        console.log('Antwort vom Server:', data);
                    } catch (error) {
                        console.error("Fehler beim Parsen der Serverantwort:", error);
                    }
                } else {
                    console.error("Fehler beim Speichern des Gewinns:", xmlHttp.status);
                }
            }
        };

        xmlHttp.open("POST", "/module/mysydeshop/b2c/ajax.php", true);
        xmlHttp.send(formData);
    }

    addToCart(segment) {
        console.log("Füge Artikel zum Warenkorb hinzu:", segment);
        const form = this.modal.querySelector('form');
        const formData = new FormData(form);
        let urlParts = window.location.pathname.split('/');

        formData.append('siteCode', urlParts[1] || '');
        formData.append('languageCode', urlParts[2] || '');
        formData.append('action', 'shop_add_protected_quantity_item');
        formData.append('qty_protected', 1);
        console.log("Segment: " + segment);
        formData.append('win_id', segment.id);
        XhrService.generalAjaxCall('cart', formData)
            .then((response) => {
                console.log("Server response:", response);
                let data;
                try {
                    data = JSON.parse(response);
                    if (data.status == "ok" && data.successful) {
                        console.log("Artikel erfolgreich zum Warenkorb hinzugefügt");
                        // Here you can add code to update the cart UI if needed
                    } else {
                        console.error("Fehler beim Hinzufügen des Artikels zum Warenkorb");
                    }
                } catch (error) {
                    console.error("Fehler beim Parsen der Serverantwort:", error);
                }
            })
            .catch((error) => {
                console.error("Fehler beim Hinzufügen des Artikels zum Warenkorb:", error);
            });
    }
}